import PropTypes from 'prop-types'
import { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { DownloadJpg } from '../../../../../../../../common/downloadJpg'
import { UseI18n } from '../../../../../../../../common/hooks/useI18n'
import { Icon } from '../../../../../../../../common/html/icon'
import { Loading } from '../../../../../../../../common/loading'
import { Panel } from '../../../../../../../../common/panel'
import { Tooltip } from '../../../../../../../../common/tooltip'
import { formatText } from '../../../../../../../../helpers/value'
import { selectCompanyInfo } from '../../../../../../../common/header/companyInfo/store/slice'

import { selectModelList, selectTypePeriod } from '../../../../../store/slice'
import { BottomContent } from './bottomContent'
import { getLoadingChartCredit } from './bottomContent/store/slice'
import {
  getDistributionPerformance,
  getTrendOfScorePerformance,
} from './bottomContent/store/thunk'
import './index.scss'
import { getLoadingRisk } from './store/slice'
import { getScorePerformance } from './store/thunk'
import { TopContent } from './topContent'

export const PerformanceScore = ({ isDynamicReport, settingDynamic }) => {
  const dispatch = useDispatch()

  const { organizationId, organizationShortName, organizationName, taxCode } =
    useSelector(selectCompanyInfo)
  const locale = useSelector((state) => state.i18n.locale)
  const TimeFrequency = useSelector(selectTypePeriod)
  const { performanceDescription } = useSelector(selectModelList)

  //loading
  const isLoadingScore = useSelector(getLoadingRisk('scorePerformance'))
  const isLoadingRange = useSelector(getLoadingRisk('RangesPerformance'))
  const isLoadingChartTrend = useSelector(getLoadingChartCredit('trendOfScore'))
  const isLoadingChartDisk = useSelector(
    getLoadingChartCredit('distributionScore'),
  )

  const label = UseI18n('score.hightLight.CORPORATE_PERFORMANCE_SCORE')

  useEffect(() => {
    if (!organizationId || isDynamicReport) return
    dispatch(
      getScorePerformance({
        OrganizationId: organizationId,
      }),
    )
    dispatch(
      getDistributionPerformance({
        OrganizationId: organizationId,
      }),
    )
  }, [locale, organizationId])

  useEffect(() => {
    if (!organizationId || isDynamicReport) return
    dispatch(
      getTrendOfScorePerformance({
        OrganizationId: organizationId,
        TimeFrequency: TimeFrequency,
      }),
    )
  }, [locale, organizationId, TimeFrequency])

  if (isDynamicReport) {
    return (
      <>
        <TopContent
          isDynamicReport={isDynamicReport}
          settingDynamic={settingDynamic}
        />
        <BottomContent
          isDynamicReport={isDynamicReport}
          settingDynamic={settingDynamic}
        />
      </>
    )
  }

  const renderRightHeader = () => {
    return (
      <DownloadJpg
        data={{
          disabled: false,
          arrName: [
            label,
            UseI18n('score.main.DETAILS'),
            organizationShortName || organizationName || taxCode || '',
          ],
          titleJpg: label,
          domId: 'TOP_COMPONENT_SCORE_PERFORMANCE',
        }}
      >
        <DownloadJpg
          data={{
            disabled: false,
            arrName: [
              label,
              UseI18n('score.premium.TREND_OF_SCORE'),
              organizationShortName || organizationName || taxCode || '',
            ],
            titleJpg: label,
            domId: 'CHART_SCORE_SCORE_PERFORMANCE',
          }}
        >
          <DownloadJpg
            data={{
              disabled: false,
              arrName: [
                label,
                UseI18n('score.premium.DISTRIBUTION.NAME_CHART'),
                organizationShortName || organizationName || taxCode || '',
              ],
              titleJpg: label,
              domId: 'CHART_DISTRIBUTION_SCORE_PERFORMANCE',
            }}
          />
        </DownloadJpg>
      </DownloadJpg>
    )
  }

  return (
    <>
      <Panel
        isI18n
        label="score.hightLight.CORPORATE_PERFORMANCE_SCORE"
        renderLabel={() => {
          return (
            <div>
              <Tooltip
                contentStyle={{
                  display: 'flex',
                  alignItems: 'center',
                  paddingLeft: 4,
                }}
                tooltipStyle={{
                  maxWidth: 400,
                }}
                tooltipContent={
                  <div className="textCenter" style={{ textAlign: 'justify' }}>
                    {formatText(performanceDescription)}
                  </div>
                }
              >
                <Icon
                  className="icon-info-circle"
                  style={{ fontSize: 16, color: '#9C9C9C' }}
                />
              </Tooltip>
            </div>
          )
        }}
        renderRightHeader={renderRightHeader}
      >
        {isLoadingRange ||
        isLoadingChartTrend ||
        isLoadingChartDisk ||
        isLoadingScore ? (
          <div className="positionRelative" style={{ height: 332 }}>
            <Loading />
          </div>
        ) : (
          <div style={{ padding: 12 }} id="SCORE_PERFORMANCE">
            <TopContent />
            <BottomContent />
          </div>
        )}
      </Panel>
    </>
  )
}

PerformanceScore.propTypes = {
  isDynamicReport: PropTypes.bool,
  settingDynamic: PropTypes.object,
}

PerformanceScore.defaultProps = {
  isDynamicReport: false,
  settingDynamic: {},
}
